import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Button, useToast } from "@aviary";
// eslint-disable-next-line @fullscript/cross-reference
import { practitionerRoutes } from "@clinic/practitioner/data/practitionerRoutes";
import FullscriptLogoSvg from "@shared/assets/logo/fullscript-logo-green-leaf-pigeon-text.svg";
import { useBreakpoints } from "@shared/hooks";
import { useLocation } from "@shared/react-router-dom";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./StoreLandingPageNavBar.styles";

interface Props {
  isPreview?: boolean;
  isStoreOwner?: boolean;
}

const StoreLandingPageNavBar: FC<Props> = ({ isPreview, isStoreOwner }) => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();
  const { pathname } = useLocation();
  const currentPath = `${location.origin}${pathname}`;
  const { makeToast } = useToast();

  const copyEmbedCode = () => {
    navigator.clipboard.writeText(currentPath);
    makeToast("success", t(l.patientRxAuth.storeLandingPages.toastCopySuccessMessage));
  };

  const fsLogo = <FullscriptLogoSvg css={styles.svgContainer} data-testid="Fullscript logo" />;

  const previewPageNav = (
    <div css={styles.navBar} data-testid="storeSignupPreviewNav">
      {tablet.lessThan && fsLogo}
      <div css={styles.buttonsContainer}>
        {isStoreOwner && (
          <Button
            href={practitionerRoutes.storeSettings.landingPage}
            css={styles.button}
            isSize="small"
          >
            {t(l.patientRxAuth.storeLandingPages.backToEdit)}
          </Button>
        )}
        <Button isColor="system" css={styles.button} onClick={copyEmbedCode} isSize="small">
          {tablet.lessThan
            ? t(l.patientRxAuth.storeLandingPages.copyLink)
            : t(l.patientRxAuth.storeLandingPages.copyStoreLink)}
        </Button>
      </div>
    </div>
  );

  const pageNav = <div css={styles.navBar}>{fsLogo}</div>;

  return (
    <>
      {isPreview && previewPageNav}
      {!isPreview && tablet.lessThan && pageNav}
    </>
  );
};

export { StoreLandingPageNavBar };
